export const REPORT_STATE_SELECTOR = "reportAffiliatesDifference";
export const REPORT_COLUMNS_KEY =
  "[REPORT ==> affiliates difference] Visible columns is:";
export const REPORT_DATE_KEY =
  "[REPORT ==> affiliates difference] Date 1 range is: ";
export const REPORT_DATE_KEY_2 =
  "[REPORT ==> affiliates difference] Date 2 range is: ";
